document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.psp-menu-toggle');
  var panel = document.querySelector('.psp-mobile-nav');
  if (!toggle || !panel) return;

  function closeMenu() {
    toggle.classList.remove('is-active');
    toggle.setAttribute('aria-expanded', 'false');
    panel.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function openMenu() {
    toggle.classList.add('is-active');
    toggle.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  toggle.addEventListener('click', function () {
    if (panel.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  panel.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 750) closeMenu();
  });
});
